require('../modules/es.parse-int');
var path = require('../internals/path');

module.exports = path.parseInt;



//////////////////
// WEBPACK FOOTER
// /home/runner/work/slipresistant/slipresistant/client/~/core-js/es/parse-int.js
// module id = T235
// module chunks = 0 3